import React from "react";
import { Col, Container, Row } from "@insightfulscience/atomic-react/Grid";
import Section from "@insightfulscience/atomic-react/Section";
import Block from "@insightfulscience/atomic-react/Block";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import ProductsTab from "@insightfulscience/atomic-react/ProductsTab";
import HeroTitle from "@insightfulscience/atomic-react/Hero/Title";
import Hero from "@insightfulscience/atomic-react/Hero";
import PricingSection from "@insightfulscience/atomic-react/r1/molecules/PricingSection";
import CardPrice from "@insightfulscience/atomic-react/CardPrice";
import CardPriceHead from "@insightfulscience/atomic-react/CardPrice/Head";
import CardPriceTitle from "@insightfulscience/atomic-react/CardPrice/Title";
import CardPriceDescription from "@insightfulscience/atomic-react/CardPrice/Description";
import CardPriceAction from "@insightfulscience/atomic-react/CardPrice/Action";
import CardPriceButtonLink from "@insightfulscience/atomic-react/CardPrice/ButtonLink";
import LandingSimpleSection from "@insightfulscience/atomic-react/LandingElement/SimpleSection";
import Line from "@insightfulscience/atomic-react/Line";
import { useLocale } from "@insightfulscience/smart-react/i18";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import UList from "@insightfulscience/atomic-react/UList";
import Inline from "@insightfulscience/atomic-react/Inline";
import CardPriceBadge from "@insightfulscience/atomic-react/CardPrice/Badge";
import Box from "@insightfulscience/atomic-react/Box";
import Icon from "@insightfulscience/atomic-react/Icon";
import Html from "@insightfulscience/smart-react/Html";
import NextLink from "@insightfulscience/smart-react/NextLink";
import SiteLayout from "../../SiteLayout";
import BiologicsHeader from "../../BiologicsHeader";
import routes from "../../routes";

const PricingBiologics = () => {
	const [t] = useLocale("pricing-biologics");
	return (
		<SiteLayout isWrapper={false} HeaderComponent={BiologicsHeader}>
			<PageMeta title={t("META.TITLE")} description={t("META.DESCRIPTION")}>
				<PageMeta.Canonical href={t("META.CANONICAL")} />
			</PageMeta>
			<Hero utility={{ bgColor: "white" }}>
				<HeroTitle>{t("HERO.TITLE")}</HeroTitle>
			</Hero>
			<Section utility={{ bgColor: "4" }}>
				<Row utility={{ bgColor: "white" }} spacing={{ pt: 9 }}>
					<Col>
						<Container>
							<Row>
								<Col md="auto">
									<NextLink
										href={routes.pricing}
										Component={ProductsTab}
										logoIcon="/images/geneious/logo/icon-prime.svg"
										borderColor="3"
										title={t("TABS.TAB_1.TITLE")}
										description={t("TABS.TAB_1.DESCRIPTION")}
									/>
								</Col>
								<Col md="auto">
									<ProductsTab
										logoIcon="/images/geneious/logo/icon-biologics.svg"
										borderColor="dotmatics-7"
										title={t("TABS.TAB_2.TITLE")}
										description={t("TABS.TAB_2.DESCRIPTION")}
										active
									/>
								</Col>
							</Row>
						</Container>
					</Col>
				</Row>
			</Section>
			<PricingSection isSeparated={false} utility={{ bgColor: "4" }}>
				<PricingSection.Header title={t("FIRST_SECTION.TITLE")}>
					{t("FIRST_SECTION.DESCRIPTION")}
				</PricingSection.Header>
				<Row mx className="mt-16 ">
					<Col>
						<PricingSection.Body lgCellWidth={12}>
							<PricingSection.Body.Item md={6} lg="auto">
								<CardPrice contentProps={{ spacing: { lg: { px: 6 } } }} className="mb-10">
									<CardPriceHead>
										<CardPriceTitle>{t("FIRST_SECTION.STARTER.TITLE")}</CardPriceTitle>
										<CardPriceDescription align="left" className="min-h-44--md">
											<Paragraph sx={{ fontSize: "m", fontColor: "black--custom-1" }}>
												{t("FIRST_SECTION.STARTER.DESCRIPTION")}
											</Paragraph>
											<Paragraph sx={{ fontSize: "m", fontWeight: "bold" }}>
												{t("FIRST_SECTION.STARTER.COST")}
											</Paragraph>
										</CardPriceDescription>
										<CardPriceAction>
											<CardPriceButtonLink
												styleType="primary"
												href="https://annotator.geneious.com/sign-up"
											>
												{t("FIRST_SECTION.STARTER.BUTTON_TEXT")}
											</CardPriceButtonLink>
										</CardPriceAction>
										<Block sx={{ textAlign: "left" }} spacing={{ mt: 6 }}>
											<Paragraph sx={{ fontSize: "m", fontWeight: "bold" }}>
												{t("FIRST_SECTION.STARTER.INCLUDED.TITLE")}
											</Paragraph>
											<UList type="pros" spacing={{ sm: { mb: 8 }, md: { mb: 0 } }}>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.STARTER.INCLUDED.ITEM_1")}
												</UList.Item>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.STARTER.INCLUDED.ITEM_2")}
												</UList.Item>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.STARTER.INCLUDED.ITEM_3")}
												</UList.Item>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.STARTER.INCLUDED.ITEM_4")}
												</UList.Item>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.STARTER.INCLUDED.ITEM_5")}
												</UList.Item>
											</UList>
										</Block>
									</CardPriceHead>
								</CardPrice>
							</PricingSection.Body.Item>
							<PricingSection.Body.Item md={6} lg="auto">
								<CardPrice contentProps={{ spacing: { lg: { px: 6 } } }} className="mb-10">
									<CardPriceHead>
										<CardPriceTitle>{t("FIRST_SECTION.PERSONAL.TITLE")}</CardPriceTitle>
										<CardPriceDescription align="left" className="min-h-44--md">
											<Paragraph sx={{ fontSize: "m", fontColor: "black--custom-1" }}>
												{t("FIRST_SECTION.PERSONAL.DESCRIPTION")}
											</Paragraph>
											<Paragraph sx={{ fontSize: "m" }} spacing={{ my: 0 }}>
												<Inline sx={{ fontWeight: "bold" }}>
													{t("FIRST_SECTION.PERSONAL.COST.ITEM_1.COST")}
												</Inline>{" "}
												{t("FIRST_SECTION.PERSONAL.COST.ITEM_1.TYPE")}
											</Paragraph>
											<Paragraph sx={{ fontSize: "m" }} spacing={{ my: 0 }}>
												<Inline sx={{ fontWeight: "bold" }}>
													{t("FIRST_SECTION.PERSONAL.COST.ITEM_2.COST")}
												</Inline>{" "}
												{t("FIRST_SECTION.PERSONAL.COST.ITEM_2.TYPE")}
											</Paragraph>
										</CardPriceDescription>

										<CardPriceAction>
											<CardPriceButtonLink styleType="primary" href={routes.quote}>
												{t("FIRST_SECTION.PERSONAL.BUTTON_TEXT")}
											</CardPriceButtonLink>
										</CardPriceAction>
										<Block sx={{ textAlign: "left" }} spacing={{ mt: 6 }}>
											<Paragraph sx={{ fontSize: "m", fontWeight: "bold" }}>
												{t("FIRST_SECTION.PERSONAL.INCLUDED.TITLE")}
											</Paragraph>
											<UList type="pros" spacing={{ sm: { mb: 8 }, md: { mb: 0 } }}>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.PERSONAL.INCLUDED.ITEM_1")}
												</UList.Item>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.PERSONAL.INCLUDED.ITEM_2")}
												</UList.Item>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.PERSONAL.INCLUDED.ITEM_3")}
												</UList.Item>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.PERSONAL.INCLUDED.ITEM_4")}
												</UList.Item>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.PERSONAL.INCLUDED.ITEM_5")}
												</UList.Item>
											</UList>
										</Block>
									</CardPriceHead>
								</CardPrice>
							</PricingSection.Body.Item>
							<PricingSection.Body.Item md={6} lg="auto">
								<CardPrice contentProps={{ spacing: { lg: { px: 6 } } }} className="mb-10">
									<CardPriceBadge className="bg-color-dotmatics-7 px-4 py-1 text-color-white">
										{t("FIRST_SECTION.GROUP.BAGE")}
									</CardPriceBadge>
									<CardPriceHead>
										<CardPriceTitle>{t("FIRST_SECTION.GROUP.TITLE")}</CardPriceTitle>
										<CardPriceDescription align="left" className="min-h-44--md">
											<Paragraph sx={{ fontSize: "m", fontColor: "black--custom-1" }}>
												{t("FIRST_SECTION.GROUP.DESCRIPTION")}
											</Paragraph>
											<Paragraph sx={{ fontSize: "m" }} spacing={{ my: 0 }}>
												<Inline sx={{ fontWeight: "bold" }}>{t("FIRST_SECTION.GROUP.COST")}</Inline>
											</Paragraph>
										</CardPriceDescription>

										<CardPriceAction>
											<CardPriceButtonLink styleType="primary" href={routes.quote}>
												{t("FIRST_SECTION.GROUP.BUTTON_TEXT")}
											</CardPriceButtonLink>
										</CardPriceAction>
										<Block sx={{ textAlign: "left" }} spacing={{ mt: 6 }}>
											<Paragraph sx={{ fontSize: "m", fontWeight: "bold" }}>
												{t("FIRST_SECTION.GROUP.INCLUDED.TITLE")}
											</Paragraph>
											<UList type="pros" spacing={{ sm: { mb: 8 }, md: { mb: 0 } }}>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.GROUP.INCLUDED.ITEM_2")}
												</UList.Item>
												<UList.Item sx={{ fontColor: "black--custom-1" }}>
													{t("FIRST_SECTION.GROUP.INCLUDED.ITEM_3")}
												</UList.Item>
											</UList>
										</Block>
									</CardPriceHead>
								</CardPrice>
							</PricingSection.Body.Item>
						</PricingSection.Body>
					</Col>
				</Row>
			</PricingSection>
			<LandingSimpleSection isBorderNone className="pt-0 pb-0" utility={{ bgColor: "4" }}>
				<LandingSimpleSection.Body>
					<Row mx px>
						<Col md={4}>
							<Box>
								<Paragraph sx={{ fontSize: "xxxl" }}>{t("SECOND_SECTION.ITEM_1.TITLE")}</Paragraph>
								<Paragraph sx={{ fontSize: "l", fontColor: "black--custom-1" }}>
									{t("SECOND_SECTION.ITEM_1.DESCRIPTION")}
								</Paragraph>
								<Paragraph>
									<NextLink href={routes.quote}>
										{t("SECOND_SECTION.ITEM_1.LINK_TEXT")} <Icon name="angle-right" color="3" />
									</NextLink>
								</Paragraph>
							</Box>
						</Col>
						<Col md={4}>
							<Box>
								<Paragraph sx={{ fontSize: "xxxl" }}>{t("SECOND_SECTION.ITEM_2.TITLE")}</Paragraph>
								<Paragraph sx={{ fontSize: "l", fontColor: "black--custom-1" }}>
									{t("SECOND_SECTION.ITEM_2.DESCRIPTION")}
								</Paragraph>
								<Paragraph>
									<NextLink href={routes.freeTrialBiologics.index}>
										{t("SECOND_SECTION.ITEM_2.LINK_TEXT")} <Icon name="angle-right" color="3" />
									</NextLink>
								</Paragraph>
							</Box>
						</Col>
						<Col md={4}>
							<Box>
								<Paragraph sx={{ fontSize: "xxxl" }}>{t("SECOND_SECTION.ITEM_3.TITLE")}</Paragraph>
								<Paragraph sx={{ fontSize: "l", fontColor: "black--custom-1" }}>
									{t("SECOND_SECTION.ITEM_3.DESCRIPTION")}
								</Paragraph>
								<Paragraph>
									<NextLink href={routes.contact.index}>
										{t("SECOND_SECTION.ITEM_3.LINK_TEXT")} <Icon name="angle-right" color="3" />
									</NextLink>
								</Paragraph>
							</Box>
						</Col>
					</Row>
				</LandingSimpleSection.Body>
			</LandingSimpleSection>
			<LandingSimpleSection isBorderNone utility={{ bgColor: "4" }}>
				<LandingSimpleSection.Body>
					<Row utility={{ justify: "center" }}>
						<Col md={10}>
							<Paragraph sx={{ fontColor: "black--custom-2", textAlign: "center" }}>
								<Html Tag="span">
									{t("SECOND_SECTION.ANNOTATE", {
										linkLicense: routes.termsOfService,
										linkContact: routes.contact.index,
									})}
								</Html>
							</Paragraph>
						</Col>
					</Row>
				</LandingSimpleSection.Body>
			</LandingSimpleSection>
			<Container utility={{ bgColor: "4" }} isFluid>
				<Row center>
					<Col sm={6}>
						<Line utility={{ border: { bottom: { width: 1, color: "black--15" } } }} />
					</Col>
				</Row>
			</Container>
			<LandingSimpleSection bgColor="4" isBorderNone>
				<LandingSimpleSection.TitleV2 spacing={{ mb: 15 }}>
					{t("FAQ.TITLE")}
				</LandingSimpleSection.TitleV2>
				<LandingSimpleSection.Body>
					<Row mx>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ.ITEM_1.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									<Html Tag="span">
										{t("FAQ.ITEM_1.ANSWER_1", {
											link: "https://annotator.geneious.com/",
											linkTry: routes.freeTrialBiologics.index,
										})}
									</Html>
								</Paragraph>
							</Block>
						</Col>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ.ITEM_2.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									{t("FAQ.ITEM_2.ANSWER_1")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									{t("FAQ.ITEM_2.ANSWER_2")}
								</Paragraph>
							</Block>
						</Col>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ.ITEM_3.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									<Html Tag="span">
										{t("FAQ.ITEM_3.ANSWER_1", {
											link: routes.featuresAntibody,
										})}
									</Html>
								</Paragraph>
							</Block>
						</Col>
					</Row>
					<Row mx spacing={{ mt: 5 }}>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ.ITEM_4.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									<Html Tag="span">
										{t("FAQ.ITEM_4.ANSWER_1", {
											linkData: routes.security,
											linkContact: routes.contact.index,
										})}
									</Html>
								</Paragraph>
							</Block>
						</Col>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ.ITEM_5.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									<Html Tag="span">
										{t("FAQ.ITEM_5.ANSWER_1", {
											link: routes.freeTrialBiologics.index,
										})}
									</Html>
								</Paragraph>
							</Block>
						</Col>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ.ITEM_6.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									<Html Tag="span">
										{t("FAQ.ITEM_6.ANSWER_1", {
											link: routes.contact.index,
										})}
									</Html>
								</Paragraph>
							</Block>
						</Col>
					</Row>
				</LandingSimpleSection.Body>
			</LandingSimpleSection>
		</SiteLayout>
	);
};

export default PricingBiologics;
